export default function smoothScrollTo (element) {
    const top = element ? element.offsetTop : 0;

    window.scrollTo({ top, behavior: 'smooth' });
}
